import { TDocTypeItem } from '~/store/types.ts';
import { TAutocompleteOption } from '~/components/AutocompleteField/types';

export const getInitialDocumentType = (
  documentTypeId: string | number | null | undefined,
  docTypes: TDocTypeItem[] | undefined
): TAutocompleteOption | null => {
  if (!documentTypeId || !docTypes?.length) return null;

  const foundType = docTypes.find((item) => String(item.id) === String(documentTypeId));
  if (!foundType?.id || !foundType.name) return null;

  return {
    value: String(foundType.id),
    label: foundType.name,
  };
};
